exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".wrapper{background-color:#fff;padding:8px;border-radius:6px;width:100%}.progress{display:flex;flex:1;height:6px;border-radius:99px;background-color:#ebebf0;overflow:hidden;position:relative}.progressbar{position:absolute;left:0;height:6px;background-color:#722ed1}.timer-counter{color:#722ed1;font-weight:bold}.title-counter-progress{font-weight:bold;width:100%;white-space:nowrap;text-overflow:ellipsis;overflow:hidden}.timer-desc-counter-progress{color:#4c4d66;font-size:12px;margin-block:8px}", ""]);

// exports
